import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const items = [
  {
    title: 'Best Quality Designs',
    content: `We deliver pixel-perfect visuals that reflect your brand's essence.`,
    icon: '🎨'
  },
  {
    title: '16x7 Live Support',
    content: `Our team is available almost all week to assist you instantly.`,
    icon: '🕒'
  },
  {
    title: 'Result Oriented Projects',
    content: `Every project is structured with clear KPIs and measurable outcomes.`,
    icon: '📊'
  },
  {
    title: 'Award Winning Support Team',
    content: `Recognized experts handle your queries with top-notch care.`,
    icon: '🏆'
  },
  {
    title: 'Experienced Professionals',
    content: `Our seasoned team offers insights that drive success.`,
    icon: '👔'
  },
];

const AboutDropdown = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = idx => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-16 sm:py-20 px-6 sm:px-8 lg:px-12 bg-white min-h-screen flex items-center">
      <div className="max-w-7xl mx-auto w-full flex flex-col lg:flex-row items-center gap-12">
        {/* Text + Accordion */}
        <div className="w-full lg:w-1/2 space-y-4">
          {items.map((item, idx) => (
            <motion.div
              key={idx}
              initial={false}
              animate={{
                y: openIndex === idx ? -2 : 0,
              }}
              transition={{ type: 'spring', stiffness: 300 }}
              className="relative"
            >
              <motion.div
                className={`p-6 rounded-2xl cursor-pointer border transition-all ${
                  openIndex === idx 
                    ? 'bg-white border-orange-200 shadow-xl' 
                    : 'bg-white border-gray-200 hover:shadow-lg'
                }`}
                onClick={() => toggle(idx)}
                whileHover={{ y: -2 }}
              >
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-4">
                    <span className="text-2xl">{item.icon}</span>
                    <h3 className={`text-xl font-semibold transition-all ${
                      openIndex === idx 
                        ? 'bg-gradient-to-r from-orange-400 via-pink-400 to-purple-400 bg-clip-text text-transparent' 
                        : 'text-gray-900'
                    }`}>
                      {item.title}
                    </h3>
                  </div>
                  <motion.span
                    className={`text-xl transition-colors ${
                      openIndex === idx ? 'text-orange-400' : 'text-gray-400'
                    }`}
                    animate={{ rotate: openIndex === idx ? 180 : 0 }}
                  >
                    ▼
                  </motion.span>
                </div>

                <AnimatePresence>
                  {openIndex === idx && (
                    <motion.p
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      className="mt-4 text-gray-600 font-light pl-12 leading-relaxed"
                    >
                      {item.content}
                    </motion.p>
                  )}
                </AnimatePresence>
              </motion.div>
            </motion.div>
          ))}
        </div>

        {/* Right-side Image */}
        <motion.div 
          className="w-full lg:w-1/2 relative"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="relative rounded-3xl overflow-hidden border border-gray-200 shadow-xl">
            <img
              src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
              alt="Professional team collaborating"
              className="w-full object-cover"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutDropdown;